import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';



/**
 * @augments {Component<{columns: any[], showCheckboxes: boolean, data:any[]}, {}>}
 */
export default class ResourceList extends Component {


  static propTypes = {
    columns: PropTypes.array,
    data: PropTypes.array
  }

  renderRow = (rowData,i) => {
    return <TableRow key={i} style={{height: 58, borderBottom: '1px solid #EFEFEF'}}>
            {this.props.columns.map((c,i)=>this.renderColumn(rowData,c,i))}
           </TableRow>
  }

  renderColumn = (rowData,c,i) => {
    let columnData = '';
    if (c.name.indexOf('.') !== -1){
      columnData = c.name.split('.').reduce((val,path)=> val[path]? val[path] : '', rowData);
    } else {
      columnData = rowData[c.name];
    }
    if (c.render) {
      columnData = c.render(rowData);
    } else if (c.formatter){
      columnData = c.formatter(columnData, c, rowData);
    } else {
      columnData = columnData?columnData.toString() : '';
    }

    return <TableRowColumn key={i} style={{width: c.width, fontSize: 18, fontWeight: '400'}}>{columnData}</TableRowColumn>
  }

  render() {
    const showCheckboxes = typeof this.props.showCheckboxes !== 'undefined'? this.props.showCheckboxes : true;
    const showHeader = typeof this.props.showHeader !== 'undefined'? this.props.showHeader : true;
    return (
      <Table>
        { showHeader
          ? <TableHeader displaySelectAll={showCheckboxes} adjustForCheckbox={showCheckboxes}>
              <TableRow>
                {this.props.columns.map((c,i)=> <TableHeaderColumn style={{width: c.width, fontSize: 14, fontWeight: '600', color: '#B7B7B7'}} key={i}>{c.label}</TableHeaderColumn>)}
              </TableRow>
            </TableHeader>
          : <span></span>
        }
        <TableBody displayRowCheckbox={showCheckboxes}>
          {this.props.data.map(this.renderRow)}
        </TableBody>
      </Table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ResourceList.js